import { render, staticRenderFns } from "./TxAgentsCommission.vue?vue&type=template&id=7d6940cc"
import script from "./TxAgentsCommission.vue?vue&type=script&lang=js"
export * from "./TxAgentsCommission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports